module.exports = __webpack_public_path__ + "assets/xmas-tree.4acf8b20.svg";